import { createAction, props } from '@ngrx/store';
import { IResponseError } from '../../service/interface';
import {
	IFactcheckSearchProviders,
	IUpdateFactcheckSearchProviderRequest,
} from '../../service/factcheck-search-provider/interface';

const loadProviders = createAction(
	'[FactcheckSearchProvider/API] Load Providers',
);

const reloadProviders = createAction(
	'[FactcheckSearchProvider/API] Reload Providers',
);

const providersReceived = createAction(
	'[FactcheckSearchProvider/API] Providers Received',
	props<{ settings: IFactcheckSearchProviders }>(),
);

const loadProvidersError = createAction(
	'[FactcheckSearchProvider/API] Load Providers Error',
	props<{ error: IResponseError }>(),
);

const updateProvider = createAction(
	'[FactcheckSearchProvider/API] Update Provider',
	props<{
		provider: string;
		changes: IUpdateFactcheckSearchProviderRequest;
	}>(),
);

const reorderProviders = createAction(
	'[FactcheckSearchProvider/API] Reorder Providers',
	props<{ providers: string[] }>(),
);

const changeSaved = createAction(
	'[FactcheckSearchProvider/API] Change Saved',
	props<{ settings: IFactcheckSearchProviders }>(),
);

const changeError = createAction(
	'[FactcheckSearchProvider/API] Change Error',
	props<{ error: IResponseError }>(),
);

export const FactcheckSearchProviderActions = {
	loadProviders,
	reloadProviders,
	providersReceived,
	loadProvidersError,
	updateProvider,
	reorderProviders,
	changeSaved,
	changeError,
};
